import { RouterProvider } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { router } from "./router";
import "react-toastify/dist/ReactToastify.css";
import { AuthProvider } from "contexts/AuthContext";

function App() {
  return (
    <AuthProvider>
    <div className="">
      <RouterProvider router={router} />
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </div>
    </AuthProvider>
  );
}

export default App;
